import Vue from 'vue';
import Login from './Login.vue';

let logo;

new Vue({
  el: '#main',
  beforeMount() {
    logo = this.$el.attributes.logo.value;
  },
  render(h) {
    return h(Login, {
      props: {
        logo,
      },
    });
  },
});
